export default __webpack_public_path__ + "static/media/CTP_Light_SP.8391fe58.svg";